import React from 'react';

import createIcon from './createIcon';

const Calendar = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <title>Calendar</title>
    <g>
      <path d="M144,128c17.7,0,32-14.3,32-32V64c0-17.7-14.3-32-32-32s-32,14.3-32,32v32C112,113.7,126.3,128,144,128z" />
      <path d="M368,128c17.7,0,32-14.3,32-32V64c0-17.7-14.3-32-32-32s-32,14.3-32,32v32C336,113.7,350.3,128,368,128z" />
      <path
        d="M472,64h-56v40.7c0,22.5-23.2,39.3-47.2,39.3S320,127.2,320,104.7V64H192v40.7c0,22.5-24,39.3-48,39.3s-48-16.8-48-39.3V64
    H40c-4.4,0-8,3.6-8,8v400c0,4.4,3.6,8,8,8h432c4.4,0,8-3.6,8-8V72C480,67.6,476.4,64,472,64z M432,432H80V176h352V432z"
      />
    </g>
  </svg>
);

export default createIcon(Calendar);
